import './action-card.scss';

import { PropsWithChildren } from 'react';

import { cn } from '../../utils/helpers';

export type ActionCardProps = PropsWithChildren & {
  className?: string;
  color?: 'negative' | 'warning';
};

/**
 * Action Card
 */
export const ActionCard: React.FC<ActionCardProps> = ({
  color,
  className,
  children,
}) => {
  const colorClass = color
    ? {
        warning: 'ActionCard--warning',
        negative: 'ActionCard--negative',
      }[color]
    : '';

  return (
    <div className={cn(['ActionCard rounded-md', colorClass, className])}>
      {children}
    </div>
  );
};

export const ActionCardSection: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="ActionCard__section py-comfy-sm md:py-comfy-lg pb-comfy-xs px-comfy-sm md:pb-comfy-md md:px-comfy-lg">
    {children}
  </div>
);

/**
 * Action Card Header
 */
export const ActionCardHeader: React.FC<
  PropsWithChildren<{ className?: string }>
> = ({ children, className = '' }) => (
  <div
    className={cn([
      'ActionCard__header flex justify-between items-center',
      className,
    ])}
  >
    {children}
  </div>
);

/**
 * Action Card Body
 */
export const ActionCardBody: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="ActionCard__body grid gap-snug-xl md:gap-comfy-sm items-center">
    {children}
  </div>
);

export const ActionCardDivider = () => <div className="ActionCard__divider" />;

/**
 * Action Card Footer
 *
 * NOTE that this should almsot always take in one or more client components.
 */
export const ActionCardFooter: React.FC<
  PropsWithChildren<{ justify?: 'end' | 'between' }>
> = ({ children, justify = 'between' }) => (
  <ActionCardSection>
    <div
      className={cn([
        'ActionCard__footer flex',
        {
          'justify-between': justify === 'between',
          'justify-end': justify === 'end',
        },
      ])}
    >
      {children}
    </div>
  </ActionCardSection>
);
